import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { Form } from './Form';
import { FormProps, SelectionProps } from './types/FormTypes';

export const RelatedForms = React.memo(
    (props: { selectionProps: SelectionProps }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps,
                selectionProps: { relatedForms },
            } = props;

            if (relatedForms.length) {
                return (
                    <div className={styles.formsGalleryViewContainer}>
                        <div className={styles.formsGalleryViewTitleContainer}>
                            {t('FormsBrowser.RelatedTitle')}
                        </div>
                        <div className={styles.formsGalleryViewSubContainer}>
                            {relatedForms?.map((form: FormProps, index) => (
                                <div key={index}>
                                    <Form
                                        form={form}
                                        selectionProps={selectionProps}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={styles.formsGalleryViewContainer}>
                        <div className={styles.formsGalleryViewTitleContainer}>
                            {t('FormsBrowser.RelatedTitle')}
                        </div>
                        <div>{t('FormsBrowser.RelatedNoResults')}</div>
                    </div>
                );
            }
        } catch {
            return null;
        }
    },
);
